/**
 * Shape constructor
 * @constructor shared.stage.components.Shape
 */
 fx.ns("shared.stage.components", class Shape extends shared.stage.base.MediaComponent{
    
	constructor(component, model, baseSVG, manual, commands)
	{
		super(component, model, baseSVG, commands, [], manual );

		this._setDefaults = manual;

		this.avoidlostBorder = true;

        this.selectable = !fx.browser.isMobile || fx.browser.isTablet;
    }


	
	get backgroundColor()
	{
		return this.data.bgcolor;
	}

	get minComponentSize()
    {
        return  {
            height : (this._shape && this._shape.id == 1) ? 1 : 10,
            width : (this._shape && this._shape.id == 1) ? 1 : 10,
        }
	}
	
	init()
    {
        super.init();

        this.updateShape(this.data.content);
	}
	
	updateShape(content) 
    {
		if (!this.model) return;

		this._shape = this.model.shapes.find({ id : content });

		if (!this._shape) return;

		this.SVGElement.svg( this._shape.svg );

		if (this._setDefaults)
			this.data.update({bgcolor : this.data.bgcolor ? this.data.bgcolor : this._shape.color, side : this.data.side ? this.data.side : this._shape.borderColor, borderid : this.data.borderid ? this.data.borderid : this._shape.borderThickness});
	}

	create()
	{
		this.svg = SVG(this.id);

		this.SVGElement = this.svg.group()
                                     //.attr("class", this.classNames)
									 .attr("data-id", this.data.id);
									 
		/*this.SVGElement = this.baseSVG.group()
                                     .attr("class", this.classNames)
                                     .attr("data-id", this.data.id);*/
	}


	onDataUpdated(action)
	{
		super.onDataUpdated(action);
		
		if (action.impacts("borderid", "side", "bgcolor"))
			this.delay(this.onDisplayUpdated, 10);


		if (action.impacts("id"))
			this.SVGElement.attr("data-id", this.data.id);
	}
	

	onDisplayUpdated()
    {
		super.onDisplayUpdated();

		if (this.SVGElement && this.SVGElement.node && this.SVGElement.node.firstChild)
		{
			this.SVGElement.node.firstChild.setAttribute("transform", "scale(" + (this.width / this._shape.width) + ","  + (this.height / this._shape.height) + ")" );
			this.SVGElement.node.firstChild.setAttribute("fill", this.data.bgcolor);
			this.SVGElement.node.firstChild.setAttribute("stroke", this.data.side);
			this.SVGElement.node.firstChild.setAttribute("stroke-width", this.data.borderid);
		}
	}

	onColor(color)
	{
		this.data.bgcolor = color;

		this.model.customcolors.addColor( color, this.model.creation.id );
	}

	onBorder(data)
	{
		this.data.update({borderid : data.thickness, side : data.color})

		this.model.customcolors.addColor( data.color, this.model.creation.id );
	}

	
	
});